<template>
    <div>
        <v-data-table :headers="colunas" :items="resultadoTabela" class="elevation-1" :footer-props="dataFooter"
            :custom-sort="sortDataTable" group-by="groupCorrelationByDate" sort-by="dataInicio">
            <template v-slot:[`group.header`]="group">
                <td colspan="15">    
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon @click="group.toggle" :color="themes.primary" v-on="on">
                                {{ group.isOpen ? 'mdi-minus' : 'mdi-plus' }}
                            </v-icon>                                   
                        </template>

                        <span v-show="group.isOpen">{{$t("Views.Onboarding.Log.Listar.retrair-agrupamento")}}</span>
                        <span v-show="!group.isOpen">{{$t("Views.Onboarding.Log.Listar.expandir-agrupamento")}}</span>
                    </v-tooltip>   

                    <span @click="group.toggle">
                        {{`Execução ${$moment.utc(tranformEpoch2Date(group.group)).local().format("DD/MM/YYYY HH")}:00:00. (Correlation Id: ${group.items[0].correlationId})`}}  
                    </span>                                                                        
                </td>
            </template>    

            <template v-slot:[`item.indicadorSucesso`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <template v-if="item.indicadorSucesso">
                            <v-icon color="success" v-on="on">
                                mdi-check
                            </v-icon>                                                
                        </template>
                        <template v-else>
                            <v-icon color="error" v-on="on">
                                mdi-close
                            </v-icon>                                                
                        </template>                                    
                    </template>

                    <span v-show="item.indicadorSucesso">{{labelIndicadorSucesso}}</span>
                    <span v-show="!item.indicadorSucesso">{{labelIndicadorErro}}</span>
                </v-tooltip>               
            </template>  

            <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.indicadorVagaExcluida == true">{{$t("Views.Onboarding.Log.Listar.vaga-excluida")}}</span>
                <span v-else-if="item.status == 1">{{$t("Views.Onboarding.Log.Listar.ticket-gerado")}}</span>
                <span v-else-if="item.status == 2">{{$t("Views.Onboarding.Log.Listar.ticket-ja-gerado")}}</span>
                <span v-else-if="item.status == 3">{{$t("Views.Onboarding.Log.Listar.erro-geracao-ticket")}}</span>
                <span v-else-if="item.status == 4">{{$t("Views.Onboarding.Log.Listar.erro-geracao-ticket")}}</span>
                <span v-else-if="item.status == 5">{{$t("Views.Onboarding.Log.Listar.em-processamento")}}</span>
                <span v-else-if="item.status == 6">{{$t("Views.Onboarding.Log.Listar.vaga-nao-nec-equipamento")}}</span>
                <span v-else>{{$t("Views.Onboarding.Log.Listar.nao-foi-possivel-identificar-operacao")}}</span>       
            </template>            

            <template v-slot:[`item.desistenciaVaga`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <template v-if="item.indicadorDesistencia">
                            <v-icon color="success" v-on="on">
                                mdi-check
                            </v-icon>                                                
                        </template>                                  
                    </template>

                    <span v-show="item.indicadorDesistencia">{{labelDesistenciaVaga}}</span>
                </v-tooltip>               
            </template>  

            <template v-slot:[`item.vagaAprovada`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <template v-if="item.indicadorAprovado">
                            <v-icon color="success" v-on="on">
                                mdi-check
                            </v-icon>                                                
                        </template>                                  
                    </template>

                    <span v-show="item.indicadorAprovado">{{labelVagaAprovada}}</span>
                </v-tooltip>               
            </template>

            <template v-slot:[`item.informacoes`]="{ item }">
                <v-icon :color="themes.primary" @click="openInformation(item)">mdi-information</v-icon>    
            </template>       

            <template v-slot:[`item.tempo`]="{ item }">
                {{getTimespan(item.dataInicio, item.dataTermino)}}              
            </template>        

            <template v-slot:[`item.dataInicio`]="{ item }">
                {{formatUtcToLocal(item.dataInicio)}}                              
            </template>                                             

            <template v-slot:no-data>{{nenhumColaboradorEncontrado}}</template>

            <template v-slot>{{realziarPesquisa}}</template>

        </v-data-table>

        <information-dialog v-model="showInformation" maxWidth="590px" :title="$t('Views.Onboarding.Log.Listar.informacoes-processamento')">
            <v-container fill-height fluid grid-list-xl>
                <v-layout wrap v-if="registroSelecionado != null">
                    <v-flex sm12 xs12 md12 lg12 grid-list-md>
                        <v-list dense>     
                            <v-list-item v-for="log in registroSelecionado.log" :key="log.id">
                                <v-list-item-content>
                                    <v-flex sm1 xs1 md1 lg1>
                                        <v-icon v-if="log.classificacaoLog.displayName == 'WARN'" medium color="warning">mdi-alert-octagon</v-icon>
                                        <v-icon v-if="log.classificacaoLog.displayName == 'ERRO'" medium color="error">mdi-close-octagon</v-icon>
                                        <v-icon v-if="log.classificacaoLog.displayName == 'APRV'" medium color="success">mdi-account-check</v-icon>
                                    </v-flex>
                                    <v-flex sm11 xs11 md11 lg11>
                                        {{log.mensagem}}                          
                                    </v-flex>         
                                </v-list-item-content>
                            </v-list-item>                     
                        </v-list>                        
                    </v-flex>
                </v-layout>
            </v-container>
        </information-dialog> 
    </div>  
</template>

<script>
    import DateMixin from '@/mixin/date'
    import FormMixin from '@/mixin/form'
    import LogIntegracaoApi from '@/api/integracao-success-factors/onboarding/log-solicitacao-contratacao'
    import InformationDialog from '@/components/material/InformationDialog'

    export default {
    mixins: [ DateMixin, FormMixin], 
    props: {
        value:{
            type: Object,
            required: false
        }
    }, 
    components: {
        "information-dialog": InformationDialog,
    },  
    watch:{
        async value(){           
            await this.consultarLog();
        }
    },
    data () {
        return { 
            resultado: [],
            colunas: [
                { text: this.$t("Views.Onboarding.Log.Listar.job-req-id"), align: 'center', value: 'codigoVaga' },
                { text: this.$t("Views.Onboarding.Log.Listar.job-app-id"), align: 'center', value: 'codigoAplicacao' },
                { text: this.$t("Views.Onboarding.Log.Listar.candidate-id"), align: 'center', value: 'codigoCandidato' },
                { text: this.$t("Views.Onboarding.Log.Listar.job-req-template-id"), align: 'center', value: 'codigoTemplate' },
                { text: this.$t("Views.Onboarding.Log.Listar.indicador-sucesso"), align: 'center', value: 'indicadorSucesso' },
                { text: this.$t("Views.Onboarding.Log.Listar.operacao"), align: 'center', value: 'status' },
                { text: this.$t("Views.Onboarding.Log.Listar.nome-solicitante"), align: 'left', value: 'nomeSolicitante' },
                { text: this.$t("Views.Onboarding.Log.Listar.codigo-ticket"), align: 'right', value: 'codigoTicket' },
                { text: this.$t("Views.Onboarding.Log.Listar.desistencia-vaga"), align: 'center', value: 'desistenciaVaga' },
                { text: this.$t("Views.Onboarding.Log.Listar.vaga-aprovada"), align: 'center', value: 'vagaAprovada' },
                { text: this.$t("Views.Onboarding.Log.Listar.tempo-processamento"), align: 'center', value: 'tempo' },
                { text: this.$t("Views.Onboarding.Log.Listar.data-inicio"), align: 'center', value: 'dataInicio' },                
                { align: 'center', value: 'informacoes' },
            ],
            showInformation: false,
            registroSelecionado: null,
        }
    },
    computed: {
        nenhumColaboradorEncontrado(){
            return this.$t("Views.Onboarding.Log.Listar.nenhum-colaborador-encontrado");
        },
        labelIndicadorSucesso(){
            return this.$t("Views.Onboarding.Log.Listar.indicador-sucesso");
        },
        labelDesistenciaVaga(){
            return this.$t("Views.Onboarding.Log.Listar.desistencia-vaga");
        },
        labelVagaAprovada(){
            return this.$t("Views.Onboarding.Log.Listar.vaga-aprovada");
        },
        labelIndicadorErro(){
            return this.$t("Views.Onboarding.Log.Listar.indicador-erro");
        },
        resultadoTabela(){
            return this.resultado || [];
        }
    },
    mounted(){
        this.consultarLog();
    },
    methods:{   
        openInformation(colaborador){
            this.showInformation = true;
            this.registroSelecionado = colaborador;
        },
        async consultarLog(){
            if(this.value == null) {
                this.resultado = [];
                return;
            }

            const loading = this.showLoading();            
            const self = this;
        
            let log = await LogIntegracaoApi.listarLogPorDataIntegracao(
                self.tranformDate2Epoch(this.value.dataInicial),
                self.tranformDate2Epoch(this.value.dataFinal),
                this.value.pais.id,
                this.value.correlationId,
                this.value.jobReqId,       
                this.value.indicadorInclusao,            
                this.value.indicadorSucesso
            ).catch(erro => self.showSnackbarError(erro.error));

            if(log.success) {
                log.data.forEach(element => {
                    element.dataInicio = self.$moment(element.dataInicio).toDate();
                    if(element.dataTermino == null)
                        element.tempo = 0;

                    else{
                        const startDate = self.$moment(element.dataInicio);
                        const endDate = self.$moment(element.dataTermino);

                        const difference = endDate.diff(startDate);                     
                        element.tempo = self.$_.parseInt(difference);

                        element.dataTermino = self.$moment(element.dataTermino).toDate();                            
                    }

                    element.status = 0;
                    if(element.indicadorNecessitaEquipamento == false){
                        element.status = 6;
                    }
                    else if(element.indicadorSucesso == true && element.indicadorInclusao == true){
                        element.status = 1;
                    }
                    else if(element.indicadorSucesso == true && element.indicadorInclusao == false){
                        element.status = 2;
                    }                   
                    else if(element.indicadorSucesso == false && element.dataTermino == null){
                        element.status = 5;
                    }                                 
                    else if(element.indicadorSucesso == false && element.indicadorInclusao == true){
                        element.status = 3;
                    }                            
                    else if(element.indicadorSucesso == false && element.indicadorInclusao == false){
                        element.status = 4;
                    } 
                });

                log.data.forEach(element => {
                    const correlationDate = this.$_.sortBy(log.data.filter(l => l.correlationId == element.correlationId), [ "dataInicio" ])[0].dataInicio;
                    element.groupCorrelationByDate = this.tranformDate2Epoch(correlationDate)
                });                    

                self.resultado = log.data;
            }
            else {                        
                self.showSnackbarError(log.error);
                throw new Error(log.error[0].userMessage);
            }                             

            loading.close(); 
        }        
    }  
}
</script>
